// The running build, shown as a small label (I-1a Batch 5 fix 3).
//
// `__APP_BUILD__` is a build-time constant injected by Vite `define`
// (vite.config.ts, from tools/ci/build-info.mjs; also present in unit tests).
// The label is permanent and the same on every channel. Until the signed
// release record exists it shows the commit and build date; in I-1a Batch 8
// (signed release.json) it switches to the signed release version.

export interface BuildInfo {
  readonly commit: string
  /** UTC build date, YYYY-MM-DD. */
  readonly date: string
}

// Fixed English month names: no Intl / locale dependency.
const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'] as const

const DATE_PATTERN = /^(\d{4})-(\d{2})-(\d{2})$/

/** "e39d318 · 15 Oct". A malformed date gives the commit alone. */
export function buildLabel(build: BuildInfo): string {
  const commit = build.commit.trim().slice(0, 7) || 'dev'
  const match = DATE_PATTERN.exec(build.date)
  if (!match) {
    return commit
  }
  const month = MONTHS[Number(match[2]) - 1]
  const day = Number(match[3])
  if (month === undefined || day < 1 || day > 31) {
    return commit
  }
  return `${commit} \u00b7 ${day} ${month}`
}

/** The label of the build that is running now. */
export function currentBuildLabel(): string {
  return buildLabel(__APP_BUILD__)
}
